import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

/**
 * HostFullscreenLayout
 * Fullscreen layout for host projector screens
 * Dark background, high contrast, minimal chrome
 * Controls (connection status, fullscreen) are integrated in each screen
 */
export default function HostFullscreenLayout() {
  useEffect(() => {
    // Exit fullscreen on unmount if active
    return () => {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
    };
  }, []);

  return (
    <div className="fullscreen-shell min-h-screen bg-neutral-900 text-white overflow-hidden">
      {/* Main content - controls now integrated in each screen */}
      <main role="main" className="h-screen flex flex-col">
        <Outlet />
      </main>
    </div>
  );
}
